import React, { Component } from 'react'
import {AsyncPaginate} from "react-select-async-paginate";
import { deleteSnippet, reporteventsnippetlist } from "../../../constants/apiParams";
import apiCall, { METHOD } from "../../../constants/baseUrl";
import { getUserID } from '../../../util/utils';
import { toast } from 'react-toastify';

export default class PaginationExample extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            report_event_snippet_list: [],
            start: 0,
            end: 1,
            hasMore: true,
            option_array:[]
        }
    }

    loadPageOptions = async (q, prevOptions, { page }) => {
         const {start,end} = this.state
        let limit = this.state.end * 10
        let opt1 = []   
         apiCall(
             METHOD.QUERY,
             reporteventsnippetlist(getUserID(), start, limit),
             (data) => {
                 if (data.is_last == 1) {
                     this.setState({ hasMore: false });
                 }
                 this.setState((prevState) => {
                     return {
                         ...this.state,
                         end: end + 1,
                         report_event_snippet_list: [...prevState.report_event_snippet_list, ...data.report_event_snippet_list],
                         isLoading: false,
                     };
                 }, () => {
                         let opt = this.state.report_event_snippet_list
                        
                         opt.map((item) => {
                             const name = item.name
                             const id = item.id
                             let obj = {}
                             obj.value=id
                             obj.lable = name
                             opt1.push(obj)
                         })
                 });
             },
             (isLoading) => { },
             (data) => {
                 toast.error(this.props.t(data.message));
             }
         );

        return {
            options: opt1,
            hasMore: this.state.hasMore,

            additional: {
                page: this.state.end
            }
        };
    };

    render() {
        const { value} = this.state
        return (
            <div>
                <h1>react-select-async-paginate</h1>
                <h2>Autoload example</h2>

                <AsyncPaginate
                    value={value}
                    loadOptions={this.loadPageOptions}
                    onChange={()=>this.setState({value})}
                    additional={{
                        page: 1,
                    }}
                />
            </div>
        )
    }
}
